export default () => ({
  activities: {
    data: []
  },
  dashboardNotifications: {
    data: []
  },
  bellNotifications: {
    data: [],
    hasMore: false,
    avatarList: [],
    hasUnread: false,
  },
  user: null,
  users: []
})
